import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { HttpErrorInterceptor } from '../network/http-error.interceptor';
import { BsDropdownConfig } from 'ngx-bootstrap/dropdown';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BsModalService } from 'ngx-bootstrap/modal';
import { provideToastr, ToastrService } from 'ngx-toastr';
import {
  NgHttpLoaderModule,
  pendingRequestsInterceptor$,
} from 'ng-http-loader';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    provideHttpClient(
      withFetch(),
      withInterceptorsFromDi(),
      withInterceptors([pendingRequestsInterceptor$])
    ),
    // importProvidersFrom(NgHttpLoaderModule.forRoot()),
    BsDatepickerConfig,
    JwtHelperService,
    BsDropdownConfig,
    provideAnimations(),
    provideToastr({
      timeOut: 1000,
      positionClass: 'toast-top-center',
    }),
    BsModalService,
    ToastrService,
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
  ],
};
